@if (gs.showSpinner$ | async) {
  <div class="scrim" [class.full]="(ns.currentLayer$ | async)?.hidden">
    <zef-spinner size="huge" mode="indeterminate" />
  </div>
}
